/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable array-callback-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/no-array-index-key */


import React, { Component } from 'react';
import { Card, CardDeck, CardBody, Col, Button, ButtonToolbar, ButtonGroup, ListGroup, ListGroupItem, Table, Input } from 'reactstrap';
import 'react-table/react-table.css';
import axios from 'axios';
import { connect } from 'react-redux';
import ActionButton from './ActionButton';


const currencyFormat = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
const URL = 'https://marketplace-api.musicmarquee.co.uk';
const REQUEST_TIMEOUT_MS = 600000;
const resultCellStyle = { whiteSpace: 'pre-line' };

const getOrderReference = (order) => {
  if (!order || typeof order !== 'object') return null;

  return order.amazon_order_id
    || order.ebay_order_id
    || order.order_id
    || order.purchase_id
    || order.discogs_purchase_id
    || order.id
    || null;
};

const getOrderStatus = (order) => {
  if (!order || typeof order !== 'object') return null;

  return order.status
    || order.order_status
    || order.purchase_status
    || order.discogs_purchase_status
    || null;
};


class ToolsUpdateOrders extends Component {
  constructor() {
    super();
    this.state = {
      amazonOrderNumber: '',
      ebayOrderNumber: '',
      discogsOrderNumber: '',
      discogsSellerId: '',
      discogsSellers: [],
      amazonResponse: { complete: false, response: undefined },
      amazonManualResponse: { complete: false, response: undefined },
      ebayManualResponse: { complete: false, response: undefined },
      discogsManualResponse: { complete: false, response: undefined },
      ebayResponse: { complete: false, response: undefined },
      purchasesResponse: { complete: false, response: undefined },
      // abdUpdateResponse: { complete: false, response: undefined },
      // abdShipResponse: { complete: false, response: undefined },
      // readyShipments: [],
      // shipmentsBatch: [],
    };
  }

  componentDidMount() {
    this.getDiscogsSellers();
  }

  getAxiosConfig() {
    return {
      headers: { Authorization: localStorage.getItem('mm_admin') },
      timeout: REQUEST_TIMEOUT_MS,
    };
  }

  async getDiscogsSellers() {
    try {
      const response = await axios.post(
        `${URL}/admin/discogs/sellers`,
        {},
        this.getAxiosConfig(),
      );

      this.setState({
        discogsSellers: response.data.sellers || [],
      });
    } catch (error) {
      this.setState({
        discogsManualResponse: { complete: false, response: 'Unable to load Discogs sellers.' },
      });
    }
  }

  getErrorMessage(error) {
    if (!error) return 'Unknown error.';

    if (error.code === 'ECONNABORTED') {
      return 'The request timed out before the server returned a response.';
    }

    if (error.response && error.response.data) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') return responseData;
      if (responseData.error) {
        return typeof responseData.error === 'string'
          ? responseData.error
          : JSON.stringify(responseData.error);
      }
      if (responseData.message) return responseData.message;
      if (responseData.detail) return responseData.detail;

      return JSON.stringify(responseData);
    }

    return error.message || 'Unknown error.';
  }

  formatUpdateResponse(data, label) {
    if (Array.isArray(data)) {
      if (data.length === 0) {
        return `No ${label} orders needed updating.`;
      }

      const orderLines = data.slice(0, 10).map((order) => {
        const reference = getOrderReference(order);
        const status = getOrderStatus(order);

        if (reference && status) return `${reference}: ${status}`;
        if (reference) return `${reference}`;
        return JSON.stringify(order);
      });

      const remaining = data.length > orderLines.length
        ? `\n...and ${data.length - orderLines.length} more.`
        : '';

      return `Updated ${data.length} ${label} ${data.length === 1 ? 'order' : 'orders'}.\n${orderLines.join('\n')}${remaining}`;
    }

    if (typeof data === 'string') return data;

    if (data && typeof data === 'object') {
      if (data.error) {
        return typeof data.error === 'string' ? data.error : JSON.stringify(data.error);
      }
      if (data.message) return data.message;
      if (data.updatedOrders && Array.isArray(data.updatedOrders)) {
        return this.formatUpdateResponse(data.updatedOrders, label);
      }
      return JSON.stringify(data);
    }

    return `Updated ${label} orders.`;
  }

  async runUpdateOrders({ endpoint, responseKey, label }) {
    this.setState({
      [responseKey]: { complete: false, response: `Updating ${label} orders...` },
    });

    try {
      const response = await axios.post(endpoint, {}, this.getAxiosConfig());

      if (response.data && response.data.error) {
        this.setState({
          [responseKey]: {
            complete: false,
            response: `Unable to update ${label} orders: ${this.formatUpdateResponse(response.data, label)}`,
          },
        });
        return true;
      }

      this.setState({
        [responseKey]: { complete: true, response: this.formatUpdateResponse(response.data, label) },
      });
    } catch (error) {
      this.setState({
        [responseKey]: { complete: false, response: `Unable to update ${label} orders: ${this.getErrorMessage(error)}` },
      });
    }

    return true;
  }

  async fetchManualOrder(channel) {
    const config = {
      amazon: {
        orderNumber: this.state.amazonOrderNumber.trim(),
        endpoint: `${URL}/admin/amazon/addorder`,
        responseKey: 'amazonManualResponse',
        label: 'Amazon',
        body: orderNumber => ({ orderIds: [orderNumber] }),
      },
      ebay: {
        orderNumber: this.state.ebayOrderNumber.trim(),
        endpoint: `${URL}/admin/ebay/addorder`,
        responseKey: 'ebayManualResponse',
        label: 'eBay',
        body: orderNumber => ({ orderIds: [orderNumber] }),
      },
      discogs: {
        orderNumber: this.state.discogsOrderNumber.trim(),
        endpoint: `${URL}/admin/discogs/orders/add`,
        responseKey: 'discogsManualResponse',
        label: 'Discogs',
        body: orderNumber => ({
          orderId: orderNumber,
          sellerId: this.state.discogsSellerId,
        }),
      },
    }[channel];

    if (!config.orderNumber) {
      this.setState({
        [config.responseKey]: { complete: false, response: `Enter a ${config.label} order number.` },
      });
      return true;
    }

    if (channel === 'discogs' && !this.state.discogsSellerId) {
      this.setState({
        discogsManualResponse: { complete: false, response: 'Enter a Discogs seller ID.' },
      });
      return true;
    }

    try {
      this.setState({
        [config.responseKey]: { complete: false, response: `Fetching ${config.label} order...` },
      });

      const response = await axios.post(
        config.endpoint,
        config.body(config.orderNumber),
        this.getAxiosConfig(),
      );

      const responseText = typeof response.data === 'string'
        ? response.data
        : this.formatUpdateResponse(response.data, config.label);

      this.setState({
        [config.responseKey]: { complete: true, response: responseText },
      });
    } catch (error) {
      const responseMessage = error.response && error.response.data
        ? error.response.data
        : error.message;

      this.setState({
        [config.responseKey]: { complete: false, response: `Unable to fetch ${config.label} order: ${responseMessage}` },
      });
    }

    return true;
  }

  async updateAmazonOrders() {
    return this.runUpdateOrders({
      endpoint: `${URL}/admin/amazon/update`,
      responseKey: 'amazonResponse',
      label: 'Amazon',
    });
  }

  async updateEbayOrders() {
    return this.runUpdateOrders({
      endpoint: `${URL}/admin/ebay/update`,
      responseKey: 'ebayResponse',
      label: 'eBay',
    });
  }

  async updateDiscogsPurchases() {
    return this.runUpdateOrders({
      endpoint: `${URL}/admin/discogs/purchases`,
      responseKey: 'purchasesResponse',
      label: 'Discogs purchases',
    });
  }

  // async updateAbdOrders() {
  //   const response = await axios.post(`${URL}/admin/aboveboard/updateall`, {}, { headers: { Authorization: localStorage.getItem('mm_admin') } });
  //   const updatedOrders = response.data;
  //   this.setState({
  //     abdUpdateResponse: {
  //       complete: true, response: `Updating Pending Orders: Complete ---
  //       Updating Unshipped Orders: Complete ---
  //       Getting New Orders: Complete`,
  //     },
  //   });
  //   return true;
  // }
  //
  // async shipAbdOrders() {
  //   const response = await axios.post(`${URL}/admin/aboveboard/ship`, {}, { headers: { Authorization: localStorage.getItem('mm_admin') } });
  //   const result = response.data;
  //   this.setState({
  //     abdShipResponse: { complete: true, response: `Admin Account: ${result.admin ? 'Shipped' : 'Not Shipped'} --  Fulfilment Account: ${result.fulfilment ? 'Shipped' : 'Not Shipped'}` },
  //   });
  //   return true;
  // }

  render() {
    return (
      <Col style={{ height: '100%' }}>
        <Card style={{ width: '100%' }}>
          <CardBody>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Complete</th>
                  <th>Result</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: '20%' }}>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Update Amazon Orders"
                      task={() => this.updateAmazonOrders()}
                    />
                  </td>
                  <td style={{ width: '10%' }}>{this.state.amazonResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td style={{ width: '70%', ...resultCellStyle }}>{this.state.amazonResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Update eBay Orders"
                      task={() => this.updateEbayOrders()}
                    />
                  </td>
                  <td>{this.state.ebayResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td style={resultCellStyle}>{this.state.ebayResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Update Discogs Purchases"
                      task={() => this.updateDiscogsPurchases()}
                    />
                  </td>
                  <td>{this.state.purchasesResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td style={resultCellStyle}>{this.state.purchasesResponse.response || ''}</td>
                </tr>
                {/* <tr>
                  <td>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Update AboveBoard Orders"
                      task={() => this.updateAbdOrders()}
                    />
                  </td>
                  <td>{this.state.abdUpdateResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td>{this.state.abdUpdateResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Ship AboveBoard Orders"
                      task={() => this.shipAbdOrders()}
                    />
                  </td>
                  <td>{this.state.abdShipResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td>{this.state.abdShipResponse.response || ''}</td>
                </tr> */ }
              </tbody>
            </Table>
          </CardBody>
        </Card>
        <Card style={{ width: '100%', marginTop: 15 }}>
          <CardBody>
            <h4>Manually Fetch Orders</h4>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Channel</th>
                  <th>Details</th>
                  <th>Complete</th>
                  <th>Result</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: '20%' }}>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Fetch Amazon Order"
                      task={() => this.fetchManualOrder('amazon')}
                    />
                  </td>
                  <td style={{ width: '30%' }}>
                    <label style={{ fontSize: 12, marginBottom: 4 }}>
                      Amazon Order Number
                    </label>
                    <Input
                      type="text"
                      bsSize="sm"
                      value={this.state.amazonOrderNumber}
                      onChange={e => this.setState({ amazonOrderNumber: e.target.value })}
                    />
                  </td>
                  <td style={{ width: '10%' }}>{this.state.amazonManualResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td style={{ width: '40%', ...resultCellStyle }}>{this.state.amazonManualResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Fetch eBay Order"
                      task={() => this.fetchManualOrder('ebay')}
                    />
                  </td>
                  <td>
                    <label style={{ fontSize: 12, marginBottom: 4 }}>
                      eBay Order Number
                    </label>
                    <Input
                      type="text"
                      bsSize="sm"
                      value={this.state.ebayOrderNumber}
                      onChange={e => this.setState({ ebayOrderNumber: e.target.value })}
                    />
                  </td>
                  <td>{this.state.ebayManualResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td style={resultCellStyle}>{this.state.ebayManualResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Fetch Discogs Order"
                      task={() => this.fetchManualOrder('discogs')}
                    />
                  </td>
                  <td>
                    <label style={{ fontSize: 12, marginBottom: 4 }}>
                      Discogs Order Number
                    </label>
                    <Input
                      type="text"
                      bsSize="sm"
                      value={this.state.discogsOrderNumber}
                      onChange={e => this.setState({ discogsOrderNumber: e.target.value })}
                    />
                    <label style={{ fontSize: 12, marginBottom: 4, marginTop: 8 }}>
                      Seller
                    </label>
                    <Input
                      type="select"
                      bsSize="sm"
                      value={this.state.discogsSellerId}
                      onChange={e => this.setState({ discogsSellerId: e.target.value })}
                    >
                      <option value="">Select Seller</option>
                      {this.state.discogsSellers.map(seller => (
                        <option key={seller.id} value={seller.id}>
                          {seller.name}
                        </option>
                      ))}
                    </Input>
                  </td>
                  <td>{this.state.discogsManualResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td style={resultCellStyle}>{this.state.discogsManualResponse.response || ''}</td>
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});

// export default connect()(SidebarContent);
export default connect(mapStateToProps)(ToolsUpdateOrders);
